import { Box, Button } from "@mui/material";
import React from "react";
import GoToIcon from "../IconComp/goToIcon";
import { ColorPallet } from "../../utils/colorPallet";

interface IProps {
  data: any[];
  title: string;
  buttonTitle: string;
  onClick?: () => void;
}

const DashboardCard = ({ data, title , buttonTitle,onClick}: IProps) => {
 
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        bgcolor: ColorPallet.bgcolor,
        border: `1px solid ${ColorPallet.borderColor}`,
        borderRadius: "4px",
        width: "100%",

      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          borderBottom: `1px solid ${ColorPallet.borderColor}`,
          paddingTop: 2,
          paddingBottom: 1,
          
        }}
      >
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: "bold",
            paddingLeft: { xs: "8px", sm: "20px" },
            marginTop: "3px",
          }}
        >
          {title}
        </Box>
        {Button && (
        <Box
          sx={{
            paddingRight: "20px",
            cursor: "pointer",
            
          }}
        >
          <Button
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              fontWeight: "normal",
              textTransform: "capitalize",
              
            }}
            onClick={onClick}
          >
            {buttonTitle}
            <GoToIcon />
          </Button>
        </Box>
      )}
      </Box>
      {data.length === 0 ? (
          <Box sx={{ p: 5, textAlign: "center" }}>No data available</Box>
        ) : (
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          p: 3,
          pt:6,
          pb:6,
        }}
      >
        {data?.map((item: any, index: number) => (
          <Box >
            <Box sx={{fontWeight:"bold",}}>
              {item?.totalMedicines}
            </Box>
            <Box sx={{mt:1,}}>{item?.title}</Box>{" "}
            
          </Box>
        ))}
      </Box>
      )}
    </Box>
  );
};

export default DashboardCard;